<section class="d-flex flex-wrap flex-column flex-md-row members" *ngIf="members">
  <div class="member-item org-provider" *ngFor="let member of members">
    <div class="member-logo-wrapper">
      <div class="member-logo">
        <a [profile]="member">
          <app-avatar [src]="member.icon | profileImg" [placeholder]="member | initials" class="img-fluid"></app-avatar>
        </a>
      </div>
    </div>
    <div class="member-content">
      <div class="member-text">
        <div class="member-title">
          <a [profile]="member">{{ member.name }}</a>
        </div>
        <div class="member-description" *ngIf="member.is_president">
          Admin
          <!-- temp renaming -->
          <!-- President -->
        </div>
      </div>
      <div class="member-explore-link" *ngIf="!(member.id | isCurrentUser | async)">
        <a
          href=""
          (click)="onConnect(member.id); $event.stopPropagation(); false"
          *ngIf="!member.is_friend; else disconnect"
          >Connect +</a
        >
        <ng-template #disconnect>
          <a href="" (click)="onDisconnect(member.id); $event.stopPropagation(); false">Disconnect</a>
        </ng-template>
      </div>
    </div>
  </div>
</section>
